export default [
    {
        //Decoration blocks (for testing):
        size: {
            height: 30,
            width: 30
        }, 
        position: {
            x: 0,
            y: 210
        }
    },
    {
        size: {
            height: 30,
            width: 30
        }, 
        position: {
            x: 160,
            y: 210
        }
    },
    {
        size: {
            height: 30,
            width: 30
        }, 
        position: {
            x: 320,
            y: 210
        }
    },
    {
        size: {
            height: 30,
            width: 30
        }, 
        position: {
            x: 480,
            y: 210
        }
    },
    //Real blocks start here:
    {
        size: {
            height: 40,
            width: 15
        }, 
        position: {
            x: 160,
            y: 0
        }
    },
    {
        size: {
            height: 50,
            width: 15
        }, 
        position: {
            x: 180,
            y: 0
        }
    },
    {
        size: {
            height: 60,
            width: 15
        }, 
        position: {
            x: 200,
            y: 0
        }
    },
    //
    {
        size: {
            height: 60,
            width: 15
        }, 
        position: {
            x: 480,
            y: 0
        }
    },
    {
        size: {
            height: 50,
            width: 15
        }, 
        position: {
            x: 500,
            y: 0
        }
    },
    {
        size: {
            height: 40,
            width: 15
        }, 
        position: {
            x: 520,
            y: 0
        }
    }
]


/** WEBPACK FOOTER **
 ** ./src/data/level2.js
 **/